import _ from 'lodash'
import { AccessLevel } from '../types'
import { inTestEnv } from '../../../lib/runtimeEnvironments'

const INJECTED_ACCESS_LEVEL_KEY = 'accessLevelOverride'

export const getInjectedAccessLevel = () => {
  if (!inTestEnv()) return
  return (window as any)[INJECTED_ACCESS_LEVEL_KEY]
}

export const setInjectedAccessLevel = (val: AccessLevel) => {
  if (!inTestEnv()) return
  ;(window as any)[INJECTED_ACCESS_LEVEL_KEY] = val
}

export const clearInjectedAccessLevel = () => {
  if (!inTestEnv()) return
  delete (window as any)[INJECTED_ACCESS_LEVEL_KEY]
}

export const injectedAccessLevelSelector = () => {
  if (!inTestEnv()) {
    return null
  }

  if (!getInjectedAccessLevel()) {
    return null
  }

  return getInjectedAccessLevel()
}

const FULL_ACCESS_ACCESS_LEVEL: AccessLevel = {
  analytics: true,
  callsList: true,
  edit: true,
  admin: true,
  copywrite: true,
  isLoggedIn: true,
  tokenLogin: true,
  view: true,
  verifiedEmail: true,
  comment: true
}

const NO_ACCESS_ACCESS_LEVEL: AccessLevel = _.mapValues(FULL_ACCESS_ACCESS_LEVEL, () => false)

export const mockAccessLevels = {
  fullAccess: FULL_ACCESS_ACCESS_LEVEL,
  noAccess: NO_ACCESS_ACCESS_LEVEL
}
